var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('div',{staticClass:"flex-row-auto offcanvas-mobile w-300px w-xl-350px",attrs:{"id":"kt_profile_aside"}},[_c('navigator')],1),_c('div',{staticClass:"flex-row-fluid ml-lg-8"},[_c('transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }